import Script from 'next/script';
import { v4 as uuidv4 } from 'uuid';
import { getConfig } from "@root/config/config";
import { getLocalStorageValue, setLocalStorageValueByKey } from "@common/utils/localStorage";
import { ExtendedWindowWithRRWidgetApi } from "@common/types/ragRecommendationWidget";
import {
  LOCAL_STORAGE_RRW_SESSION_ID_KEY,
  RAG_RECOMMENDATION_WIDGET_IFRAME_Z_INDEX
} from "@common/constants/ragRecommendationWidget";

const config = getConfig();

export function ChatLoader() {
  const initChat = async () => {
    const widget = (window as ExtendedWindowWithRRWidgetApi)?.RagRecommendationWidget;

    if (widget){
      let sessionId = getLocalStorageValue(LOCAL_STORAGE_RRW_SESSION_ID_KEY);

      if (!sessionId){
        sessionId = uuidv4();
        setLocalStorageValueByKey(LOCAL_STORAGE_RRW_SESSION_ID_KEY, sessionId)
      }

      widget.init({
        sessionId,
        zIndex: RAG_RECOMMENDATION_WIDGET_IFRAME_Z_INDEX,
        debugLogging: ['development', 'staging'].includes(config.env)
      });
    }
  }

  return (
    <Script
      src={`${config.ragRecommendationWidget.url}/widget.js`}
      strategy="afterInteractive"
      onLoad={initChat}
    />
  );
}
